import { useMemo } from "react";
import {
    getSingleQueryValue,
    hasActiveInlineProviderFilters,
    splitCsv,
} from "../searchParams";
import type { ProviderFilterValues } from "./types";

export const useProviderFilterValues = (
    activeFilters: HashMap<unknown>,
    queryValues: HashMap<unknown>,
): ProviderFilterValues => {
    const mergedFilters = useMemo(
        () => ({ ...activeFilters, ...queryValues }),
        [activeFilters, queryValues],
    );

    return {
        selectedCategories: splitCsv(mergedFilters.filter_categories),
        selectedSubcategories: splitCsv(mergedFilters.filter_subcategories),
        selectedCity: getSingleQueryValue(mergedFilters.filter_city),
        selectedPostedPeriod: getSingleQueryValue(mergedFilters.filter_posted_period),
        selectedRadius: getSingleQueryValue(mergedFilters.filter_range),
        selectedMinRating: getSingleQueryValue(mergedFilters.filter_min_rating),
        selectedCoordinatesLat: getSingleQueryValue(mergedFilters.filter_coordinates_lat),
        selectedCoordinatesLon: getSingleQueryValue(mergedFilters.filter_coordinates_lon),
        currentKeyword: getSingleQueryValue(mergedFilters.filter_keyword).trim(),
        activeFilterState: mergedFilters,
        hasInlineProviderFilters: hasActiveInlineProviderFilters(mergedFilters),
    };
};
